webpackJsonp([6],{

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(749);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotFound.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotFound.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "button:focus{outline:none}._2bWBG{width:100%;height:100%;padding:20px 30px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column;min-height:100vh}._2bWBG>svg{opacity:.5}._2bWBG>div{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}._2bWBG>div:first-child{margin-right:50px}._2bWBG p{color:#878787;font-size:25px;margin-bottom:10px}._2bWBG button{color:#4e4dae;background-color:transparent;font-size:20px;font-weight:600;cursor:pointer;margin-top:10px}._2bWBG button>span{margin-right:5px}._2bWBG button:hover{color:#878787}", ""]);

// exports
exports.locals = {
	"notFound": "_2bWBG"
};

/***/ }),

/***/ 757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 12 modules
var Layout = __webpack_require__(238);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(11);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(57);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./src/routes/not-found/NotFound.css
var not_found_NotFound = __webpack_require__(748);
var NotFound_default = /*#__PURE__*/__webpack_require__.n(not_found_NotFound);

// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(40);

// CONCATENATED MODULE: ./src/routes/not-found/NotFound.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = _jsx("svg", {
  height: "512",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, _jsx("path", {
  d: "M136 121l-16 96H56l-16-96",
  fill: "#fff"
}), _jsx("path", {
  d: "M72 217h32v216H72z",
  fill: "#b9c2cf"
}), _jsx("path", {
  d: "M88 217h16v216H88zM152 121H24l64-64z",
  fill: "#95a4b6"
}), _jsx("path", {
  d: "M88 57L76 69l52 52h24z",
  fill: "#72869e"
}), _jsx("path", {
  d: "M24 433a32 32 0 0164 0",
  fill: "#b9c2cf"
}), _jsx("path", {
  d: "M56 401l-8 1c14 4 24 16 24 31h16c0-17-14-32-32-32z",
  fill: "#95a4b6"
}), _jsx("path", {
  d: "M88 433a48 48 0 1196 0",
  fill: "#b9c2cf"
}), _jsx("path", {
  d: "M136 385l-8 1c23 4 40 23 40 47h16c0-26-21-48-48-48z",
  fill: "#95a4b6"
}), _jsx("path", {
  d: "M6 433h500v24H6z",
  fill: "#dce1e7"
}), _jsx("path", {
  d: "M486 433h20v24h-20zM208 361h280v32H208z",
  fill: "#b9c2cf"
}), _jsx("path", {
  d: "M208 377h280v16H208z",
  fill: "#95a4b6"
}), _jsx("path", {
  d: "M232 297h224v32H232z",
  fill: "#b9c2cf"
}), _jsx("path", {
  d: "M436 297h20v32h-20z",
  fill: "#95a4b6"
}), _jsx("path", {
  d: "M232 233h224v32H232z",
  fill: "#b9c2cf"
}), _jsx("path", {
  d: "M436 233h20v32h-20z",
  fill: "#95a4b6"
}), _jsx("path", {
  d: "M478 427v-28h16v-44h-56v-20h24v-44h-24v-20h24v-44H226v44h24v20h-24v44h24v20h-48v44h16v28h-28a54 54 0 00-80-41V223h34v-12h-17l14-84h25L88 49l-78 78h25l14 84H32v12h34v174a38 38 0 00-48 30H0v36h512v-36zM238 239h212v20H238zm24 32h164v20H262zm-24 32h212v20H238zm24 32h164v20H262zm-48 32h268v20H214zm16 32h236v28H230zm-30 40v12h-88v-12zm12 0h88v12h-88zm100 0h88v12h-88zm-176-48c21 0 39 16 42 36H94c2-10 7-19 15-26h1v-1c7-5 16-9 26-9zm-21-180H94v-84h35zM88 66l50 49H38zm-41 61h35v84H61zm31 96h20v172c-5 5-8 10-11 16l-9-9zM56 407c12 0 23 9 25 20H31c2-11 13-20 25-20zm-44 32h88v12H12zm488 12h-88v-12h88z",
  fill: "#012d4a"
}));

var _ref2 = _jsx("p", {}, void 0, "This page does not exist");

var _ref3 = _jsx("span", {
  className: "mdi mdi-home"
});

var NotFound_NotFound =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NotFound, _React$Component);

  function NotFound() {
    _classCallCheck(this, NotFound);

    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
  }

  _createClass(NotFound, [{
    key: "render",
    value: function render() {
      return _jsx("div", {
        className: NotFound_default.a.notFound
      }, void 0, _ref, _jsx("div", {}, void 0, _ref2, _jsx("button", {
        onClick: function onClick() {
          return src_history["a" /* default */].push('/');
        }
      }, void 0, _ref3, "Go home")));
    }
  }]);

  return NotFound;
}(react_default.a.Component);

/* harmony default export */ var routes_not_found_NotFound = (withStyles_default()(NotFound_default.a)(NotFound_NotFound));
// CONCATENATED MODULE: ./src/routes/not-found/index.js
var not_found_REACT_ELEMENT_TYPE;

function not_found__jsx(type, props, key, children) { if (!not_found_REACT_ELEMENT_TYPE) { not_found_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: not_found_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }




var title = 'Page Not Found';

var not_found__ref = not_found__jsx(Layout["a" /* default */], {
  headerBackground: "white"
}, void 0, not_found__jsx(routes_not_found_NotFound, {
  title: title
}));

function action() {
  return {
    chunks: ['not-found'],
    title: title,
    component: not_found__ref,
    status: 404
  };
}

/* harmony default export */ var not_found = __webpack_exports__["default"] = (action);

/***/ })

});


// WEBPACK FOOTER //
// not-found.85ffc84d.chunk.js